import { ChevronDown, ChevronUp } from 'lucide-react'

/** The first few items of a long list show; this quiet full-width control reveals or folds the rest. */
export const FOLD_COUNT = 3

export function FoldToggle({
  expanded,
  total,
  noun,
  controls,
  onToggle,
}: {
  expanded: boolean
  total: number
  /** Plural, e.g. "actions" → "Show all 7 actions". */
  noun: string
  /** Id of the list this toggle shows and hides. */
  controls?: string
  onToggle: () => void
}) {
  const Icon = expanded ? ChevronUp : ChevronDown
  return (
    <button
      type="button"
      aria-expanded={expanded}
      aria-controls={controls}
      onClick={onToggle}
      className="flex min-h-9 w-full items-center justify-center gap-1.5 rounded-md py-1.5 text-sm font-medium text-foreground/80 transition-colors hover:bg-muted hover:text-foreground focus-visible:bg-muted focus-visible:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50"
    >
      <Icon className="size-4 shrink-0" aria-hidden="true" data-fold-icon={expanded ? 'up' : 'down'} />
      {expanded ? 'Show fewer' : `Show all ${total} ${noun}`}
    </button>
  )
}
